var React = require('react');

function AngleDown (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M7.70312 9.54688C8.125 9.96875 8.82812 9.96875 9.25 9.54688L15.625 3.17188C16.0938 2.70312 16.0938 2 15.625 1.57812L14.5938 0.5C14.125 0.078125 13.4219 0.078125 13 0.5L8.45312 5.04688L3.95312 0.5C3.53125 0.078125 2.82812 0.078125 2.35938 0.5L1.32812 1.57812C0.859375 2 0.859375 2.70312 1.32812 3.17188L7.70312 9.54688Z","fill":"#313444"}));
}

AngleDown.defaultProps = {"width":"17","height":"10","viewBox":"0 0 17 10","fill":"none"};

module.exports = AngleDown;

AngleDown.default = AngleDown;
